import {css} from 'lit';
export const styles = css`:host {
  --padding-block: 16px;
  --border: var(--border-light-secondary);
  --bg: var(--body-bg);

  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  height: var(--page-header-height);
  border-bottom: 1px solid var(--border);
  background-color: var(--bg);
  z-index: 900;
}

ef-icon {
  --secondary: var(--badge-color);

  font-size: 1.5em;
}

a {
  --link-text: var(--contrast-dark);

  display: flex;
  align-items: center;
  padding: var(--padding-block);
}

a.focus-visible {
  outline-offset: -2px;
}

a:focus-visible {
  outline-offset: -2px;
}

a:active {
  --link-text-active: var(--dark-text-secondary);
}

aside {
  display: flex;
}

main {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  padding: var(--padding-block) 110px;
  z-index: -1;
}

:host([theme='primary']) {
  --border: transparent;
  --bg: var(--primary);

  display: flex;
  align-items: flex-start;
  color: var(--contrast-light);
}

:host([theme='primary']) a {
    --link-text: #fff;

    align-items: flex-start;
  }

@media (hover: hover) {
    :host([theme='primary']) a:hover {
      --link-text-hover: #a4cdc8;
    }
  }

:host([theme='primary']) a:active {
    --link-text-active: #fff;
  }
`;
export default styles;
